export function LegalProblemSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row gap-12">
        <div className="flex-1">
          <h2 className="text-[32px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
            Legal growth is linear.<br />Paralegal capacity is the constraint.
          </h2>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-4">
            More cases means more people. Document review, data extraction, form preparation, compliance checks: paralegal work is the single largest bottleneck to scaling a law firm.
          </p>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-5">
            This isn&apos;t a technology gap. It&apos;s a structural one.
          </p>

          {/* Scenario block */}
          <div>
            <p className="text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase text-[var(--color-fg-tertiary)] mb-2">
              A typical day at a 5-person immigration firm
            </p>
            <ul className="space-y-1">
              {[
                "3 hours preparing a single Skilled Worker application",
                "45 minutes cross-checking a passport against bank statements",
                "20 minutes formatting a cover letter from a previous template",
                "15 minutes chasing a client for a missing utility bill",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="mt-[5px] w-[3px] h-[3px] rounded-full shrink-0 bg-[var(--color-fg-tertiary)]" />
                  <span className="text-[11px] text-[var(--color-fg-tertiary)] leading-snug">{item}</span>
                </li>
              ))}
            </ul>
            <p className="text-[11px] text-[var(--color-fg-tertiary)] mt-2 italic">Multiply that across 60 cases a month.</p>
          </div>
        </div>

        <div className="w-[35%] shrink-0">
          <div className="flex flex-col justify-start w-full pl-10 -my-4 py-4 gap-6 border-l border-[var(--color-border)]">
            {[
              { value: "3 hrs", label: "Average time per application form" },
              { value: "70%", label: "Of fee-earner time spent on admin" },
              { value: "Minutes", label: "With AI-assisted preparation" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-[36px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
                  {stat.value}
                </div>
                <div className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          The real constraint isn&apos;t legal knowledge. It&apos;s operational capacity.
        </p>
      </div>
    </div>
  );
}
